import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RecordLength, EActionType, EDataTableType } from '../../data/Constants';
import { IPaginationRequest } from '../../../types/IApiTypes';
import { IQueue } from '../../../types';
import { updateMaintenanceRowData, updateTableData } from '../utilities/SliceDataHelper';
import { AppState } from '../AppStore';
import { ProductReleaseApi } from '../../api/ProductReleaseApi';

export const productReleaseSliceState: IQueue = {
  data: {},
  totalCount: 0,
  currentPage: 1,
  recordsPerPage: RecordLength[0],
  searchKey: '',
  searchData: {},
};

//This action call the getProductRelease api method to fetch the product releases.
export const getProductRelease = createAsyncThunk(
  'productRelease/getProductRelease',
  async (action: IPaginationRequest, thunkAPI) => {
    return ProductReleaseApi.getProductReleaseData(action, thunkAPI.dispatch);
  }
);

//To retrigger product release
export const retriggerProductRelease = createAsyncThunk(
  'productRelease/retriggerProductRelease',
  async (action: { id: string; activities: string[] }, thunkAPI) => {
    return ProductReleaseApi.retriggerProductRelease(action, thunkAPI.dispatch);
  }
);

const ProductReleaseSlice = createSlice({
  name: 'productRelease',
  initialState: productReleaseSliceState,
  reducers: {},
  extraReducers: (builder) => {
    //To get the data to state
    builder.addCase(getProductRelease.fulfilled, (state, action) => {
      if (!('error' in action.payload)) {
        if (!action.payload.searchKey) {
          updateTableData(state, action.payload, false, EDataTableType.ProductRelease);
        } else if (action.payload.searchKey) {
          if (action.meta.arg.caller === EActionType.Refresh) {
            updateMaintenanceRowData(
              state.data,
              action.payload.data,
              state.currentPage,
              action.payload.searchKey,
              EDataTableType.ProductRelease
            );
          } else {
            updateTableData(state, action.payload, true);
          }
        }
      }
    });
  },
});

export const productRelease = (state: AppState) => state.productRelease;

export default ProductReleaseSlice.reducer;
